// Correlation is not payment authority. Persist no credentials or provider data.
const storageKey = 'checkout-start-recovery-v1';
export const recoveryMessage =
  'We could not confirm your existing checkout. Your edits are kept. Please retry checkout to check its status before paying.';

export const recoveryScope = (state) =>
  JSON.stringify([
    state.main?.user?.id,
    state.restaurant?.selectedRestaurantId,
    state.order?.checkoutPurchaseRevision || 0,
    state.authorization?.checkoutSessionRevision || 0,
  ]);

export function readCheckoutRecovery(state) {
  const scope = recoveryScope(state);
  const valid = (record) =>
    record?.scope === scope &&
    record.request?.client === state.restaurant.selectedRestaurantId &&
    /^[a-zA-Z0-9]{32,64}$/.test(record.request?.start_attempt || '');
  if (valid(state.order.checkoutRecovery)) return state.order.checkoutRecovery;
  // Session storage survives reload without sharing draft correlation between
  // tabs. Local storage is only a fallback when session storage is unavailable.
  const stores = ['sessionStorage', 'localStorage'];
  for (let index = 0; index < stores.length; index += 1) {
    try {
      const record = JSON.parse(window[stores[index]].getItem(storageKey));
      if (valid(record)) return record;
    } catch (_error) {
      // Try the other browser store. Starting is forbidden if neither can save.
    }
  }
  return null;
}

export function persistCheckoutRecovery(record) {
  const stores = ['sessionStorage', 'localStorage'];
  for (let index = 0; index < stores.length; index += 1) {
    try {
      window[stores[index]].setItem(storageKey, JSON.stringify(record));
      return;
    } catch (_error) {
      // A second independent store may still be usable.
    }
  }
  throw new Error(
    'Checkout recovery could not be saved in this browser. Please allow browser storage and retry. Your cart has been kept.'
  );
}

export function clearCheckoutRecovery() {
  ['sessionStorage', 'localStorage'].forEach((name) => {
    try {
      window[name].removeItem(storageKey);
    } catch (_error) {
      // Purchase revision also invalidates this record if removal is blocked.
    }
  });
}

export function createCheckoutRecovery(state, request) {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  const startAttempt = Array.from(bytes, (byte) =>
    byte.toString(16).padStart(2, '0')
  ).join('');
  return {
    scope: recoveryScope(state),
    request: JSON.parse(
      JSON.stringify({ ...request, start_attempt: startAttempt })
    ),
  };
}

export const checkoutErrorData = (error) =>
  error?.data?.data || error?.response?.data?.data || error?.data || {};
